module.exports = __webpack_public_path__ + "img/2f_r_fukumitsu_2.33be2366.jpg";